<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-radio
                    formControlName="perTnsSalarie"
                    direction="column"
                    [isDefault]="false"
                    columns="2"
                    [options]="perTnsSalarieOptions"
                    label="TNS (déductibilité en tant que TNS) ou Tout public  (déductibilité en tant que salarié)"
                  >
                  </pr-input-radio>
                </div>
                <ng-container>
                  <div class="col col-md-6">
                    <pr-input-date
                      label="Date de début de l'exercice fiscal"
                      formControlName="perTnsCompanyFirstFiscalYear"
                      [derrors]="derrors"
                      [isDefault]="false"
                      [hidden]="
                        product?.get('parameters')?.get('perTnsSalarie')
                          ?.value != 'TNS'
                      "
                      [required]="
                        product?.get('parameters')?.get('perTnsSalarie')
                          ?.value === 'TNS'
                      "
                    ></pr-input-date>
                  </div>
                  <div class="col col-md-6">
                    <pr-input-date
                      label="Date de création de l'entreprise"
                      formControlName="perTnsCompanyCreationDate"
                      [derrors]="derrors"
                      [isDefault]="false"
                      [hidden]="
                        product?.get('parameters')?.get('perTnsSalarie')
                          ?.value != 'TNS'
                      "
                      [required]="
                        product?.get('parameters')?.get('perTnsSalarie')
                          ?.value === 'TNS'
                      "
                    ></pr-input-date>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
